import { call, put, takeLatest } from 'redux-saga/effects';
import api from '../../api/api';
import { CREATE_ORDER, CREATE_ORDER_SUCCESS, CREATE_ORDER_FAILURE } from '../types';

function postCreateOrder(data) {
  return api.post('orders', { ...data }, {
    headers: { 'Content-Type': 'application/json; charset=UTF-8' },
  });
}

function* handleCreateOrder(action) {
  try {
    const response = yield call(postCreateOrder, action.payload);
    
    // Check if response contains an error message or error code
    if (response.data && (response.data.message && response.data.code) && response.data.code.startsWith('ERROR')) {
      yield put({ type: CREATE_ORDER_FAILURE, error: response.data.message });
      return;
    }
    
    yield put({ type: CREATE_ORDER_SUCCESS, payload: response.data });
  } catch (error) {
    // Extract error message from various possible formats
    let message = 'Failed to submit order. Please try again.';

    if (error?.response?.data) {
      if (typeof error.response.data === 'string') {
        message = error.response.data;
      } else if (error.response.data.error) {
        message = error.response.data.error;
      } else if (error.response.data.message) {
        message = error.response.data.message;
      }
    } else if (error?.message) {
      message = error.message;
    }

    yield put({ type: CREATE_ORDER_FAILURE, error: message });
  }
}

export default function* orderSaga() {
  yield takeLatest(CREATE_ORDER, handleCreateOrder);
}
